export default "__VITE_ASSET__BTkTHTen__"